import { CreateWaferImagingTemplateRequestSchema, UpdateWaferImagingTemplateRequestSchema, WaferImagingTemplateIdParamSchema, WaferImagingTemplateListResponseSchema, WaferImagingTemplateResponseSchema, } from '../../efem-wafer-imaging.schemas.js';
import { BaseResponseSchema } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/tenant/wafer-imaging-templates.routes.ts`. */
export const waferImagingTemplatesContract = {
    list: {
        method: 'GET',
        path: '/tenant/wafer-imaging-templates',
        response: WaferImagingTemplateListResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'templates',
        errorMessage: 'Failed to list wafer imaging templates',
    },
    getById: {
        method: 'GET',
        path: '/tenant/wafer-imaging-templates/:id',
        pathParams: WaferImagingTemplateIdParamSchema,
        response: WaferImagingTemplateResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'template',
        errorMessage: 'Failed to get wafer imaging template',
    },
    create: {
        method: 'POST',
        path: '/tenant/wafer-imaging-templates',
        body: CreateWaferImagingTemplateRequestSchema,
        response: WaferImagingTemplateResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'template',
        errorMessage: 'Failed to create wafer imaging template',
    },
    update: {
        method: 'PATCH',
        path: '/tenant/wafer-imaging-templates/:id',
        pathParams: WaferImagingTemplateIdParamSchema,
        body: UpdateWaferImagingTemplateRequestSchema,
        response: WaferImagingTemplateResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'template',
        errorMessage: 'Failed to update wafer imaging template',
    },
    delete: {
        method: 'DELETE',
        path: '/tenant/wafer-imaging-templates/:id',
        pathParams: WaferImagingTemplateIdParamSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to delete wafer imaging template',
    },
};
//# sourceMappingURL=wafer-imaging-templates.contract.js.map